import React from 'react';

export const Modal = ({ id, children, open, onClose, className }) => {

    let classNames = className;
    const openClassName = (open) ? ' tccmodal -open' : ' tccmodal ';
    classNames += openClassName;

    const handleClose = (e) => {
        e.preventDefault();
        onClose();
    }

    return (
        <div className={classNames} data-modal={id}>

            <div className="container">

                <div className="tccmodal-content-wrap">

                    <a className="tccmodal-close" href="#close" onClick={handleClose}><span className="x"></span></a>

                    <div className="tccmodal-content">

                        {children}

                    </div>

                </div>

            </div>

        </div>
    );

}